import { TenantJob } from '~/tenants/common/TenantJob';
import { NepOrderContext, NepPerformableConfig } from '~/tenants/nep/model/NepOrder';

export default abstract class NepJob<P extends NepPerformableConfig> extends TenantJob<NepOrderContext, P> {}
